// import Pages from "./components/Pages"
// import './App.css';
import "./index.css"
import About from './components/About';

function App() {
return (
<div className=" bg-black text-white">
     <About />
 
  
    </div>
    );
}; 
  

export default App;